import { connect } from 'react-redux'

import ErrorPage from './page'

const ErrorGuard = (props) => {
  const message = props.failure || (props.error && props.error.payload && props.error.payload.failure)

  if (message) {
    return <ErrorPage {...props} error={message} />
  }

  return props.children
}

const mapStateToProps = (state) => ({
  error: state.error,
  failure: state.failure,
  profile: state.profile,
  current_user: state.current_user
})

export default connect(
  mapStateToProps
)(ErrorGuard)
